import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { Utils } from '../../services';

@Component({
  selector: 'mj-snack-bar',
  templateUrl: './snackbar.template.html',
  styleUrls: ['./snackbar.style.scss'],
})
export class SnackBarComponent implements OnInit, OnChanges {
  @Input() options: any;

  @Input() collapse: any;

  @Output() emitClose = new EventEmitter<any>();

  private timeout: any;

  constructor(public $u: Utils) {}

  public ngOnInit() {
    this._setOptions();
  }

  public ngOnChanges(changes) {
    this._setOptions();
  }

  public buttonClick() {
    this.emitClose.emit(true);
  }

  private _setOptions() {
    clearTimeout(this.timeout);
    this.options = Object.assign(
      {
        text: 'Text',
        buttonText: 'OK',
        timeout: 3000,
      },
      this.options
    );

    this.timeout = setTimeout(() => {
      this.emitClose.emit(true);
    }, this.options.timeout);
  }
}
